import ExcelExampleTable, {
  MaximoCaracter,
  NaoForPreenchido,
  ExcelExampleTableRow,
} from "ui/components/ExcelExampleTable";

function TabelaExemplo() {
  return <ExcelExampleTable rows={rows} />;
}

const rows: ExcelExampleTableRow[] = [
  {
    cabecalho: "unidade",
    tipo: "texto",
    obrigatorio: "Sim",
    observacao: MaximoCaracter(10),
  },
  {
    cabecalho: "bloco",
    tipo: "texto",
    observacao: MaximoCaracter(20),
  },
  {
    cabecalho: "fracao",
    tipo: "decimal",
    observacao: 'Casas decimais separadas por "."',
  },
  {
    cabecalho: "peso",
    tipo: "decimal",
    observacao: 'Casas decimais separadas por "."',
  },
  {
    cabecalho: "area",
    tipo: "decimal",
    observacao: 'Casas decimais separadas por "."',
  },
  {
    cabecalho: "area_construida",
    tipo: "decimal",
    observacao: 'Casas decimais separadas por "."',
  },
  {
    cabecalho: "abatimento",
    tipo: "decimal",
    observacao: `Só insira um abatimento se foi decidido em assembléia uma isenção para esta unidade em decorrência da participação do condômino no conselho ou como síndico.
    Casas decimais separadas por "."`,
  },

  {
    cabecalho: "proprietario_nome",
    tipo: "texto",
    obrigatorio: "Sim",
    observacao: MaximoCaracter(200),
  },
  {
    cabecalho: "proprietario_cpf/cnpj",
    tipo: "texto",
    obrigatorio: "Sim",
    observacao: MaximoCaracter(20),
  },
  {
    cabecalho: "proprietario_telefone",
    tipo: "texto",
    observacao: MaximoCaracter(35),
  },
  {
    cabecalho: "proprietario_celular",
    tipo: "texto",
    observacao: MaximoCaracter(35),
  },
  {
    cabecalho: "proprietario_endereco",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(300)}</NaoForPreenchido>,
  },
  {
    cabecalho: "proprietario_numero",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(150)}</NaoForPreenchido>,
  },
  {
    cabecalho: "proprietario_complemento",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(350)}</NaoForPreenchido>,
  },
  {
    cabecalho: "proprietario_bairro",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(150)}</NaoForPreenchido>,
  },
  {
    cabecalho: "proprietario_cidade",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(100)}</NaoForPreenchido>,
  },
  {
    cabecalho: "proprietario_estado",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(2)}</NaoForPreenchido>,
  },
  {
    cabecalho: "proprietario_cep",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(300)}</NaoForPreenchido>,
  },
  {
    cabecalho: "proprietario_rg",
    tipo: "texto",
    observacao: MaximoCaracter(20),
  },
  {
    cabecalho: "proprietario_email",
    tipo: "texto",
    obrigatorio: "Sim",
    observacao: MaximoCaracter(200),
  },
  {
    cabecalho: "inquilino_nome",
    tipo: "texto",
    observacao: MaximoCaracter(200),
  },
  {
    cabecalho: "inquilino_cpf/cnpj",
    tipo: "texto",
    observacao: MaximoCaracter(20),
  },
  {
    cabecalho: "inquilino_telefone",
    tipo: "texto",
    observacao: MaximoCaracter(35),
  },
  {
    cabecalho: "inquilino_celular",
    tipo: "texto",
    observacao: MaximoCaracter(35),
  },
  {
    cabecalho: "inquilino_endereco",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(300)}</NaoForPreenchido>,
  },
  {
    cabecalho: "inquilino_numero",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(150)}</NaoForPreenchido>,
  },
  {
    cabecalho: "inquilino_complemento",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(350)}</NaoForPreenchido>,
  },
  {
    cabecalho: "inquilino_bairro",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(150)}</NaoForPreenchido>,
  },
  {
    cabecalho: "inquilino_cidade",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(100)}</NaoForPreenchido>,
  },
  {
    cabecalho: "inquilino_estado",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(2)}</NaoForPreenchido>,
  },
  {
    cabecalho: "inquilino_cep",
    tipo: "texto",
    observacao: <NaoForPreenchido>{MaximoCaracter(300)}</NaoForPreenchido>,
  },
  {
    cabecalho: "inquilino_rg",
    tipo: "texto",
    observacao: MaximoCaracter(20),
  },
  {
    cabecalho: "inquilino_email",
    tipo: "texto",
    observacao: MaximoCaracter(200),
  },
];

export default TabelaExemplo;
